<!-- ======= Footer ======= -->
<footer id="footer">
  <div class="container">
    <h3>Diego Pagini</h3>
    <div class="social-links">
      <a
        href="https://www.linkedin.com/in/diego-pagini-3b5401189/"
        target="_blank"
        class="linkedin"
        ><i class="bx bxl-linkedin"></i
      ></a>
      <a href="https://github.com/diegopagini" target="_blank" class="github"
        ><i class="bx bxl-github"></i
      ></a>
      <a href="mailto:diegopaginidev@gmail.com" target="_blank" class="gmail"
        ><i class="bx bxl-google"></i
      ></a>
      <a
        href="https://www.instagram.com/diegohp.dev/?hl=es-la"
        target="_blank"
        class="instagram"
        ><i class="bx bxl-instagram"></i
      ></a>
      <a
        href="https://api.whatsapp.com/send?phone=635221024"
        target="_blank"
        class="whatsapp"
        ><i class="bx bxl-whatsapp"></i
      ></a>
    </div>
  </div>
</footer>
<!-- End Footer -->
